import { Component, Inject, OnInit } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { SettingsService } from './core/services/settings.service';
import { UserService } from './core/services/user.service';
import { OfflineDetectionService } from './core/services/offline-detection.service';
import { NetworkErrorService } from './core/services/network-error.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'somos-client-portal';
  isOffline$ = this.offlineService.isOffline$;
  showTimeoutBanner$ = this.networkErrorService.showTimeoutBanner$;
  showGenericError$ = this.networkErrorService.showGenericError$;

  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private translate: TranslateService,
    private settingsService: SettingsService,
    private us: UserService,
    private offlineService: OfflineDetectionService,
    private networkErrorService: NetworkErrorService,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.matIconRegistry.addSvgIcon(
      'picture-as-png',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/icons/png.svg'
      )
    );
    this.matIconRegistry.addSvgIcon(
      'picture-as-jpg',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/icons/jpg.svg'
      )
    );
    this.matIconRegistry.addSvgIcon(
      'picture-as-pdf',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/icons/pdf.svg'
      )
    );
    this.matIconRegistry.addSvgIcon(
      'custom_chat',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/icons/chat-outline.svg'
      )
    );
    this.matIconRegistry.addSvgIcon(
      'custom_filter_outline',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/icons/icon-filter-outline.svg'
      )
    );
    this.matIconRegistry.addSvgIcon(
      'custom_filter_filled',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/icons/icon-filter-filled.svg'
      )
    );
    this.matIconRegistry.addSvgIcon(
      'custom_filter_clear',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/icons/icon-filter-clear-2.svg'
      )
    );
    this.matIconRegistry.addSvgIcon(
      'git_branch_deleted',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/icons/git-branch-deleted.svg'
      )
    );

    this.settingsService.getSettings();
  }

  async ngOnInit() {
    // this.us.refresh();

    // Mantém o atributo <html lang> sincronizado com o idioma ativo.
    // Sem isso, o index.html fica fixo em lang="en" e o tradutor automático
    // do navegador tenta "traduzir" o conteúdo em português, corrompendo
    // textos como "No mar" -> "Sem marca".
    this.syncHtmlLang(this.translate.currentLang || this.translate.defaultLang);
    this.translate.onLangChange.subscribe(({ lang }) =>
      this.syncHtmlLang(lang)
    );
  }

  private syncHtmlLang(lang: string | undefined): void {
    if (!lang) return;
    const htmlLang = lang.toLowerCase().startsWith('pt') ? 'pt-BR' : 'en';
    this.document.documentElement.setAttribute('lang', htmlLang);
  }

  retryRequest() {
    this.networkErrorService.triggerRetry();
  }

  refreshPage() {
    window.location.reload();
  }

  closeGenericError() {
    this.networkErrorService.hideGenericError();
  }
}

